import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import DateRangePicker from '../../util_components/date_range_picker';
import {
  readPeriodParams,
  resolvePeriod,
  buildPeriodSearch,
  ECONOMY_START_DATE
} from './period_utils';
import './trial_points.css';

// URL-controlled period picker shared by the /trial_points pages. The URL is the single
// source of truth: this reads the resolved period from it and writes the chosen range back
// as explicit custom dates; the pages derive their period from the URL the same way.
function PeriodFilter() {
  const history = useHistory();
  const location = useLocation();
  const { range, customStart, customEnd } = readPeriodParams(location.search);
  const { startDate, endDate } = resolvePeriod(range, customStart, customEnd);

  const onApply = ({ startDate: nextStart, endDate: nextEnd }) => {
    history.replace({
      pathname: location.pathname,
      search: buildPeriodSearch(location.search, 'custom', nextStart, nextEnd)
    });
  };

  return (
    <div className="tp-filter">
      <span style={{ color: 'var(--text-primary)', fontWeight: 700, fontSize: '16px' }}>
        Period:
      </span>
      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        onApply={onApply}
        tillDateStart={ECONOMY_START_DATE}
      />
    </div>
  );
}

export default PeriodFilter;
